export const Configs = {
    baseUrl: 'https://admin.intelligent-playground.com'
}